import {Film} from "@/modules/Rhizome/interfaces/film.interface";

export interface IState {
  filmsList: Film.IFilm[];
  viewType: RhizomeViewType;
  showFavorites: boolean;
  filterByKeyword: Film.IKeyword;
  preActiveFilm: number;
  scaleCloud: number;
  ordersFilmList: any[];
  filterByKeywordName: string;
  errorOnRequest: boolean;
}

export enum RhizomeViewType {
  CLOUD,
  CIRCLE,
  LIST,
}
